module.exports = __webpack_public_path__ + "img/big4-5.491b0ade.jpg";